import { Text, View } from '@components/primitives';
import { getStore } from '@store/storeUtils';
import { scale, verticalScale } from '@utils/normalize';
import { SVG_ICONS } from '@utils/SvgIcons';
import React from 'react';
import { useTranslation } from 'react-i18next';

const AppliedReferral: React.FC = () => {
  const { validatedReferralCode } = getStore() as { validatedReferralCode?: string };
  const { t } = useTranslation('common');

  if (validatedReferralCode) {
    return (
      <View flexDirection="row" alignItems="center" style={{ marginTop: verticalScale(21) }}>
        <View>{SVG_ICONS.referral.giftTwo}</View>
        <View flex={1} style={{ marginLeft: scale(7) }}>
          <Text testID="appliedReferralContainer" variant="sm-normal">
            {t('referral.appliedReferral1')} <Text variant="sm-bold">{t('referral.appliedReferral2')}</Text>{' '}
            {t('referral.appliedReferral3')}
          </Text>
        </View>
      </View>
    );
  }
  return null;
};

export default React.memo(AppliedReferral);
